/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-13 17:48:15
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-13 17:48:45
 * @Description: 上传类型
 * @FilePath: /hsylc2021/src/components/form/Uploader/uploadType.js
 */
export default {
  ALBUM: 'album',
  AVATAR: 'avatar',
  FILE: 'file'
};
